module.exports = __webpack_public_path__ + "static/media/white_text.9972eb02.svg";